import React, { useEffect, useState } from "react";
import dayjs, { type Dayjs } from "dayjs";
import { Box } from "@mui/material";

const HeaderTime = (): React.ReactElement => {
  const [currentTime, setCurrentTime] = useState<Dayjs>(dayjs());

  // Automatically upadate time and set in currentTime
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(dayjs());
    }, 1000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const timeString = currentTime.format("ddd, hh:mm:ss A");

  return (
    <Box
      component="span"
      style={{
        fontSize: "1.75rem"
      }}
    >
      {" "}
      {timeString}
    </Box>
  );
};
export default React.memo(HeaderTime);
